{
  "name": "55-(19-Limit) < 256°",
  "description": "55-tone Rational Intonation gamut, consisting of pitch classes derived from odd harmonic partials not exceeding 256° and comprising only products of primes <= 19. This set combines all of the preceding pitches, and adds primes 17° and 19° along with their multiples. The limit is chosen because it is the highest prime that allows a complete 13-Limit harmony to be constructed within the partials up to 256, and because the addition of 17° and 19° produce a more even scale. The resulting harmonic space subset is therefore maximally compact while providing the most consonant modulations in seven dimensions (3°, 5°, 7°, 11°, 13°, 17°, 19°).",
  "scale": [
    "65/64",
    "33/32",
    "133/128",
    "135/128",
    "17/16",
    "35/32",
    "143/128",
    "9/8",
    "147/128",
    "75/64",
    "19/16",
    "153/128",
    "77/64",
    "39/32",
    "5/4",
    "81/64",
    "165/128",
    "21/16",
    "169/128",
    "85/64",
    "171/128",
    "175/128",
    "11/8",
    "45/32",
    "91/64",
    "187/128",
    "189/128",
    "95/64",
    "3/2",
    "195/128",
    "49/32",
    "99/64",
    "25/16",
    "51/32",
    "13/8",
    "209/128",
    "105/64",
    "27/16",
    "55/32",
    "221/128",
    "7/4",
    "225/128",
    "57/32",
    "231/128",
    "117/64",
    "119/64",
    "15/8",
    "121/64",
    "243/128",
    "245/128",
    "247/128",
    "125/64",
    "63/32",
    "255/128",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "OddPartials(19L)",
  "built_in_group": "Odd Partial Pitch Class Sets",
  "key_labels": "note_names",
  "note_names": [
    "1",
    "65",
    "33",
    "133",
    "135",
    "17",
    "35",
    "143",
    "9",
    "147",
    "75",
    "19",
    "153",
    "77",
    "39",
    "5",
    "81",
    "165",
    "21",
    "169",
    "85",
    "171",
    "175",
    "11",
    "45",
    "91",
    "187",
    "189",
    "95",
    "3",
    "195",
    "49",
    "99",
    "25",
    "51",
    "13",
    "209",
    "105",
    "27",
    "55",
    "221",
    "7",
    "225",
    "57",
    "231",
    "117",
    "119",
    "15",
    "121",
    "243",
    "245",
    "247",
    "125",
    "63",
    "255"
  ],
  "note_colors": [
    "#ff9393",
    "#e9d7d3",
    "#dfffd6",
    "#f4e6f2",
    "#fffae5",
    "#cfcfcf",
    "#ffcba8",
    "#90f9cd",
    "#ffffff",
    "#f8c9c9",
    "#fef5be",
    "#d6f7ff",
    "#cfcfcf",
    "#e9ecc1",
    "#e6d7fe",
    "#fffae5",
    "#ffffff",
    "#ddfe95",
    "#ffe5e5",
    "#dbb3ff",
    "#eceae4",
    "#d6f7ff",
    "#ffd270",
    "#dfffd6",
    "#fffae5",
    "#ebd0e0",
    "#ccdbce",
    "#ffe5e5",
    "#e5fff9",
    "#ffffff",
    "#e9d7d3",
    "#f8c9c9",
    "#dfffd6",
    "#fef5be",
    "#cfcfcf",
    "#e6d7fe",
    "#caf7e3",
    "#ffcba8",
    "#ffffff",
    "#ddfe95",
    "#c3b4d5",
    "#ffe5e5",
    "#fef5be",
    "#d6f7ff",
    "#e9ecc1",
    "#e6d7fe",
    "#ded4d5",
    "#fffae5",
    "#c3ffad",
    "#ffffff",
    "#ffb59a",
    "#dbe6ff",
    "#ffef8a",
    "#ffe5e5",
    "#eceae4"
  ],
  "equivSteps": 55,
  "fundamental": 440,
  "reference_degree": 38,
  "center_degree": 0,
  "rSteps": 8,
  "drSteps": 5,
  "hexSize": 38,
  "rotation": -8.2
}
